import { render, staticRenderFns } from "./Allestimenti.vue?vue&type=template&id=37dd9b96&scoped=true&"
import script from "./Allestimenti.vue?vue&type=script&lang=js&"
export * from "./Allestimenti.vue?vue&type=script&lang=js&"
import style0 from "./Allestimenti.vue?vue&type=style&index=0&id=37dd9b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd9b96",
  null
  
)

export default component.exports